export const countries = {
  AD: "Andorra",
  AE: "Emirados Árabes Unidos",
  AF: "Afeganistão",
  AG: "Antígua e Barbuda",
  AI: "Anguila",
  AL: "Albânia",
  AM: "Armênia",
  AO: "Angola",
  AQ: "Antártida",
  AR: "Argentina",
  AS: "Samoa Americana",
  AT: "Áustria",
  AU: "Austrália",
  AW: "Aruba",
  AX: "Ilhas Aland",
  AZ: "Azerbaijão",
  BA: "Bósnia e Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Bélgica",
  BF: "Burkina Faso",
  BG: "Bulgária",
  BH: "Bahrein",
  BI: "Burundi",
  BJ: "Benin",
  BL: "São Bartolomeu",
  BM: "Bermudas",
  BN: "Brunei",
  BO: "Bolívia",
  BQ: "Bonaire, Santo Eustáquio e Saba",
  BR: "Brasil",
  BS: "Bahamas",
  BT: "Butão",
  BV: "Ilha Bouvet",
  BW: "Botsuana",
  BY: "Bielorrússia",
  BZ: "Belize",
  CA: "Canadá",
  CC: "Ilhas Cocos (Keeling)",
  CD: "Congo (República Democrática do)",
  CF: "República Centro-Africana",
  CG: "Congo",
  CH: "Suíça",
  CI: "Costa do Marfim",
  CK: "Ilhas Cook",
  CL: "Chile",
  CM: "Camarões",
  CN: "China",
  CO: "Colômbia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cabo Verde",
  CW: "Curaçao",
  CX: "Ilha Christmas",
  CY: "Chipre",
  CZ: "Tchéquia",
  DE: "Alemanha",
  DJ: "Djibuti",
  DK: "Dinamarca",
  DM: "Dominica",
  DO: "República Dominicana",
  DZ: "Argélia",
  EC: "Equador",
  EE: "Estônia",
  EG: "Egito",
  EH: "Saara Ocidental",
  ER: "Eritreia",
  ES: "Espanha",
  ET: "Etiópia",
  FI: "Finlândia",
  FJ: "Fiji",
  FK: "Ilhas Malvinas (Falkland)",
  FM: "Micronésia (Estados Federados da)",
  FO: "Ilhas Faroe",
  FR: "França",
  GA: "Gabão",
  GB: "Reino Unido da Grã-Bretanha e Irlanda do Norte",
  GD: "Granada",
  GE: "Geórgia",
  GF: "Guiana Francesa",
  GG: "Guernsey",
  GH: "Gana",
  GI: "Gibraltar",
  GL: "Groenlândia",
  GM: "Gâmbia",
  GN: "Guiné",
  GP: "Guadalupe",
  GQ: "Guiné Equatorial",
  GR: "Grécia",
  GS: "Ilhas Geórgia do Sul e Sandwich do Sul",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guiné-Bissau",
  GY: "Guiana",
  HK: "Hong Kong",
  HM: "Ilha Heard e Ilhas McDonald",
  HN: "Honduras",
  HR: "Croácia",
  HT: "Haiti",
  HU: "Hungria",
  ID: "Indonésia",
  IE: "Irlanda",
  IL: "Israel",
  IM: "Ilha de Man",
  IN: "Índia",
  IO: "Território Britânico do Oceano Índico",
  IQ: "Iraque",
  IR: "Irã (República Islâmica do)",
  IS: "Islândia",
  IT: "Itália",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordânia",
  JP: "Japão",
  KE: "Quênia",
  KG: "Quirguistão",
  KH: "Camboja",
  KI: "Kiribati",
  KM: "Comores",
  KN: "São Cristóvão e Névis",
  KP: "Coreia (República Popular Democrática da)",
  KR: "Coreia (República da)",
  KW: "Kuwait",
  KY: "Ilhas Cayman",
  KZ: "Cazaquistão",
  LA: "Laos",
  LB: "Líbano",
  LC: "Santa Lúcia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Libéria",
  LS: "Lesoto",
  LT: "Lituânia",
  LU: "Luxemburgo",
  LV: "Letônia",
  LY: "Líbia",
  MA: "Marrocos",
  MC: "Mônaco",
  MD: "Moldávia",
  ME: "Montenegro",
  MF: "São Martinho (parte francesa)",
  MG: "Madagascar",
  MH: "Ilhas Marshall",
  MK: "Macedônia do Norte",
  ML: "Mali",
  MM: "Mianmar",
  MN: "Mongólia",
  MO: "Macau",
  MP: "Ilhas Marianas do Norte",
  MQ: "Martinica",
  MR: "Mauritânia",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Maurício",
  MV: "Maldivas",
  MW: "Malawi",
  MX: "México",
  MY: "Malásia",
  MZ: "Moçambique",
  NA: "Namíbia",
  NC: "Nova Caledônia",
  NE: "Níger",
  NF: "Ilha Norfolk",
  NG: "Nigéria",
  NI: "Nicarágua",
  NL: "Países Baixos",
  NO: "Noruega",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nova Zelândia",
  OM: "Omã",
  PA: "Panamá",
  PE: "Peru",
  PF: "Polinésia Francesa",
  PG: "Papua Nova Guiné",
  PH: "Filipinas",
  PK: "Paquistão",
  PL: "Polônia",
  PM: "São Pedro e Miquelão",
  PN: "Pitcairn",
  PR: "Porto Rico",
  PS: "Palestina, Estado da",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguai",
  QA: "Catar",
  RE: "Reunião",
  RO: "Romênia",
  RS: "Sérvia",
  RU: "Rússia",
  RW: "Ruanda",
  SA: "Arábia Saudita",
  SB: "Ilhas Salomão",
  SC: "Seychelles",
  SD: "Sudão",
  SE: "Suécia",
  SG: "Singapura",
  SH: "Santa Helena, Ascensão e Tristão da Cunha",
  SI: "Eslovênia",
  SJ: "Svalbard e Jan Mayen",
  SK: "Eslováquia",
  SL: "Serra Leoa",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somália",
  SR: "Suriname",
  SS: "Sudão do Sul",
  ST: "São Tomé e Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten (parte holandesa)",
  SY: "República Árabe Síria",
  SZ: "Eswatini",
  TC: "Ilhas Turks e Caicos",
  TD: "Chade",
  TF: "Territórios Franceses do Sul",
  TG: "Togo",
  TH: "Tailândia",
  TJ: "Tajiquistão",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turcomenistão",
  TN: "Tunísia",
  TO: "Tonga",
  TR: "Turquia",
  TT: "Trinidad e Tobago",
  TV: "Tuvalu",
  TW: "Taiwan (Província da China)",
  TZ: "Tanzânia, República Unida da",
  UA: "Ucrânia",
  UG: "Uganda",
  UM: "Ilhas Menores Distantes dos Estados Unidos",
  US: "Estados Unidos da América",
  UY: "Uruguai",
  UZ: "Uzbequistão",
  VA: "Santa Sé",
  VC: "São Vicente e Granadinas",
  VE: "Venezuela (República Bolivariana da)",
  VG: "Ilhas Virgens (Britânicas)",
  VI: "Ilhas Virgens (E.U.A.)",
  VN: "Vietnã",
  VU: "Vanuatu",
  WF: "Wallis e Futuna",
  WS: "Samoa",
  YE: "Iêmen",
  YT: "Mayotte",
  ZA: "África do Sul",
  ZM: "Zâmbia",
  ZW: "Zimbábue",
} as const;
